import { Typography, Button, Link, Dialog, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { TextStdRg } from '@/UI/AppTypography/AppTypography';
import { WeavyLogoFilled } from '@/UI/Icons/WeavyLogoFilled';
import { I18N_KEYS } from '@/language/keys';
import { EXTERNAL_LINKS } from '@/consts/externalLinks.consts';

export function TermsOfServiceDialog({ onAccept }: { onAccept: () => void }) {
  const { t } = useTranslation();

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: color.Black92,
          backgroundImage: 'none',
          borderRadius: '13px',
          p: 4,
          pt: 5,
          position: 'relative',
        },
      }}
    >
      {/* Weavy logo */}
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          bgcolor: color.White100,
          border: `2px solid ${color.Black92}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <WeavyLogoFilled width={28} height={24} style={{ color: color.Black100 }} />
      </Box>

      {/* Title */}
      <Typography variant="body-lg-sb" sx={{ color: color.White100, mb: 1 }}>
        {t(I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_TITLE)}
      </Typography>

      {/* Body */}
      <TextStdRg sx={{ alignSelf: 'stretch', mb: 4 }}>
        {t(I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_BODY)}{' '}
        <Link
          href={EXTERNAL_LINKS.termsOfService}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: color.White64_T, textDecorationColor: color.White64_T }}
        >
          {t(I18N_KEYS.SIGN_IN_PAGE.TERMS_OF_SERVICE_LINK)}
        </Link>{' '}
        and{' '}
        <Link
          href={EXTERNAL_LINKS.privacyPolicy}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: color.White64_T, textDecorationColor: color.White64_T }}
        >
          {t(I18N_KEYS.SIGN_IN_PAGE.PRIVACY_POLICY_LINK)}
        </Link>
        .
      </TextStdRg>

      {/* Continue button */}
      <Button
        variant="contained"
        onClick={onAccept}
        fullWidth
        sx={{
          borderRadius: '4px',
          bgcolor: color.Yellow100,
          color: color.Black100,
          fontWeight: 500,
          fontSize: '14px',
          height: '32px',
          '&:hover': { bgcolor: color.Yellow64 },
        }}
      >
        {t(I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_ACCEPT_BUTTON)}
      </Button>
    </Dialog>
  );
}
